// extracted by mini-css-extract-plugin
export default {"wrapper":"Km-z","viewport":"Lm-z","container":"Mm-z","slide":"Nm-z"};